<template>
    <div class="modal fade modal-previewArticle" id="previewArticle" tabindex="-1" aria-labelledby="previewArticleLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Preview Artikel</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="!loading">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loading-block v-if="loading" />
                    <div v-else>
                        <div class="preview-img">
                            <img :src="!isEmpty(data.media) ? data.media.fullpath : '/assets/images/icons/image.png'">
                        </div>
                        <h1 class="title">{{ data.judul }}</h1>
                        <div class="preview-summary">
                            {{ data.deskripsi }}
                        </div>
                        <div class="preview-desc" v-html="data.konten"></div>
                        <div v-if="sections.length > 0">
                            <div v-for="item in sections" v-bind:key="item" class="mt-3">
                                <h3 class="sub-title mb-1">{{ item.title }}</h3>
                                <div v-if="item.type === 'image'">
                                    <figure>
                                        <img :src="item.media.image" :alt="item.media.title">
                                        <figcaption>{{ item.media.title }}</figcaption>
                                    </figure>
                                </div>
                                <div v-html="item.description"></div>
                            </div>
                        </div>
                        <div class="preview-tag">
                            <ul>
                                <li v-for="item in data.tag" v-bind:key="item">{{ item }}</li>
                            </ul>
                        </div>
                        <hr/>
                        <div>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="check">
                                <label class="form-check-label" for="check">Pastikan tulisanmu telah bersih dari typo dan mengikuti syarat dan ketentuan tulisan yang ada.</label>
                            </div>
                        </div>
                        <hr/>
                        <div class="recaptcha-wrap">
                            <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                            <span>Wajib diisi</span>
                        </div>
                        <hr/>
                        <div class="button-wrap">
                            <button class="btn btn-primary main-button pill-button bg-orange" @click="publish">Submit</button>
                            <button class="btn btn-primary main-button pill-button" @click="draft">Save As Draft</button>
                            <button class="btn btn-primary main-button pill-button bg-red" @click="edit">Back to edit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
export default {
    props: ['data', 'sections', 'loading'],
    name: "PreviewArticle",
    methods: {
        isEmpty (value) {
            return _.isEmpty(value)
        },
        edit() {
            $('#previewArticle').modal('hide')
        },
        draft() {
            this.$emit('submit', true);
        },
        publish() {
            this.$emit('submit', false);
        },
        handleRecaptcha(response) {
            if(response) {
                this.$emit('recaptcha', response);
            }
        },
    }
}
</script>

<style scoped>
.modal-previewArticle .modal-content {
    background-color: #EAECF0;
    border-radius: 15px;
    border: none;
}
.preview-img {
    background: #fff;
    border-radius: 15px;
}
.preview-img p {
    padding: 10px;
}
.preview-img img {
    width: 100%;
    border-radius: 15px;
}
.preview-summary {
    border-left-color: black;
    padding: 1rem;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    border: 0 solid #F8222E;
    border-left-width: .25rem;
    border-radius: .25rem;
    border-top: 1px solid #BDBDBD;
    border-right: 1px solid #BDBDBD;
    border-bottom: 1px solid #BDBDBD;
    font-weight: 600;
    font-size: 12px;
}
.preview-tag ul {
    list-style-type: none;
    display: flex;
    justify-content: flex-start;
    -webkit-padding-start: 0;
    padding-inline-start: 0;
    margin-bottom: 0;
}
.preview-tag ul li {
    border: 1px solid #828282;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 4px 6px;
    margin-right: 10px;
}
.preview-tag ul li a {
    color: #828282;
    text-decoration: none;
}
.preview-desc img {
    width: 100%;
    height: auto;
}
.title {
    margin-top: 10px;
    font-size: 25px;
}
.sub-title {
    margin-top: 10px;
    font-size: 18px;
}
img {
    width: 100%;
    height: auto;
}
figure {
    text-align: center;
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
    .modal-dialog {
        max-width: 600px;
    }
}
@media only screen and (min-width: 800px) {
    .modal-dialog {
        max-width: 700px;
    }
}
</style>
